import insighttAPI from '../clients/insightt-api-client';
import { authenticated } from '../../helpers/auth-header';
import { notificationsEndpoints } from '../endpoints';

const getNotifications = (currentPage, pageSize, config = {}) =>
  authenticated(insighttAPI, config).get(notificationsEndpoints.getNotificationsAPI(currentPage, pageSize));

const markAsReadNotifications = (payload) =>
  authenticated(insighttAPI).put(notificationsEndpoints.markAsReadNotificationsAPI(), payload);

const deleteNotifications = (payload) =>
  authenticated(insighttAPI).delete(notificationsEndpoints.deleteNotificationsAPI(), null, {
    data: payload,
  });

const deleteNotification = (id) =>
  authenticated(insighttAPI).delete(notificationsEndpoints.deleteNotificationAPI(id));

const markAsReadAllNotifications = () =>
  authenticated(insighttAPI).post(notificationsEndpoints.markReadAllNotificationsAPI(), {});

export const notificationsService = {
  getNotifications,
  markAsReadNotifications,
  deleteNotifications,
  deleteNotification,
  markAsReadAllNotifications,
};
